import Button from "@/ui/components/Button"
import * as TrinityAPI from "@/requests/TrinityAPI"

import { useEffect, useState, type FC } from "react"

import style from "../style.module.scss"
import { ModalPopUp } from "@/components/common/element/ModalPopUp"
import { IModalMessage } from "@/types/error/IModalMessage"
import { IExchangeListItem, IExchangeQueryProps } from "@/types/exchange/IExchangeDto"
import { IPageResponse } from "@/types/IPageResponse"
import { IUser } from "@/types/user/IUser"
import Table from "@/ui/components/Table"
import Skeleton from "@/ui/components/Skeleton"
import InfiniteScroll from "react-infinite-scroll-component"
import EmptyRow from "@/ui/components/EmptyRow"
import { getFormattedDate, spacedNum } from "@/components/common/CommonHelper"
import { ModalConfirm } from "@/components/common/element/ModalConfirm"

type Props = {
  user: IUser
  onClose: () => void
  refetch: () => void
}

const tableColumns: string[] = [
  "Сумма к обмену",
  "Валюта к обмену",
  "Курс обмена",
  "Обмен на валюту",
  "Сумма в валюте",
  "Время",
  "Действия"
]

export const CurrencyExchangeHistory: FC<Props> = ({ user, onClose, refetch }) => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [confirmMessage, setConfirmMessage] = useState<IModalMessage>()
  const [exchangeList, setExchangeList] = useState<IPageResponse<IExchangeListItem>>()
  const [page, setPage] = useState<number>(0)
  const [isLoading, setIsLoading] = useState(true)
  const [isActionLoading, setIsActionLoading] = useState(false)

  const confirmRollBack = (val: number | undefined) => {
    if (val) {
      handleRollBack(val)
    }
  }

  const handleRollBack = (id: number) => {
    setIsActionLoading(true)

    TrinityAPI.rollBackUserExchange(
      id,
      response => {
        if (response.status === 200) {
          refetch()
          onClose()
        } else {
          setModalMessage({ title: "Ошибка!", text: "Ошибка отката операции: " + response.data.message })
        }
      },
      () => setIsLoading(false)
    )
  }

  const fetchData = () => {
    if (!user?.userId) return

    const payload: IExchangeQueryProps = {
      page,
      userId: user.userId
    }

    TrinityAPI.getUserExchangeHistory(
      payload,
      response => {
        if (response.status === 200) {
          const currentItems =
            page === 0 ? new Array<IExchangeListItem>() : exchangeList?.items || new Array<IExchangeListItem>()
          setPage(page + 1)

          setExchangeList({
            ...exchangeList,
            items: currentItems.concat(response.data.items),
            totalPages: response.data.totalPages
          })
        } else {
          setModalMessage({ title: "Ошибка!", text: "Ошибка загрузки истории обменов: " + response.data.message })
        }
      },
      () => setIsLoading(false)
    )
  }

  useEffect(() => {
    if (user?.userId) {
      fetchData()
    }
  }, [user?.userId])

  if (!user?.userId) {
    return null
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} error={undefined} />
      <ModalConfirm
        message={confirmMessage}
        setMessage={() => setConfirmMessage(undefined)}
        className="index-top-top"
      />
      <section className="popup-forms index-top" id="error-popup">
        <div className="container-popup-forms exchange-history-popup">
          <button className="close-btn-card" id="password-close" onClick={onClose} />
          <div className="popup-card overflow-hidden">
            <div className={style.exchangeHistory}>
              <Table.Wrapper title={`История обменов для пользователя ${user.name}`}>
                {isLoading ? (
                  <Skeleton rows={2} />
                ) : (
                  <InfiniteScroll
                    scrollableTarget="scrollable"
                    next={fetchData}
                    hasMore={page < (exchangeList?.totalPages || 0)}
                    loader={<>Загрузка...</>}
                    dataLength={exchangeList?.items.length || 0}
                    className="message-list"
                    style={{ listStyleType: "none" }}
                  >
                    <div>
                      <Table.Header className={style.exchangeHistoryTableRow} columns={tableColumns} />
                      {(exchangeList?.items?.length || 0) > 0 ? (
                        exchangeList?.items.map((ex, index) => (
                          <Table.Item className={style.exchangeHistoryTableRow} key={ex.id}>
                            <div>{ex.amountToExchange ? spacedNum(ex.amountToExchange / 100) : "-"}</div>
                            <div>{ex.fromCurrency || "-"}</div>
                            <div>{ex.exchangeRate || "-"}</div>
                            <div>{ex.toCurrency || "-"}</div>
                            <div>{ex.amountToCredit ? spacedNum(ex.amountToCredit / 100) : "-"}</div>
                            <div>{ex.createdAt ? getFormattedDate(ex.createdAt) : "-"}</div>
                            <div className={style.rowActionsColumn}>
                              <Button
                                size="small"
                                disabled={isActionLoading}
                                onClick={() =>
                                  setConfirmMessage({
                                    title: "Удалить обмен?",
                                    text: `Вы действительно желаете удалить операцию?`,
                                    callbackValue: ex.id,
                                    _callback: confirmRollBack
                                  })
                                }
                              >
                                Удалить
                              </Button>
                            </div>
                          </Table.Item>
                        ))
                      ) : (
                        <EmptyRow text="Обменов не найдено" />
                      )}
                    </div>
                  </InfiniteScroll>
                )}
              </Table.Wrapper>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
